module.exports = __webpack_public_path__ + "img/introduceBg.ceaadb00.png";